const logPrefix = ['%c[uploader]:', 'font-weight: bolder; color: blue'];
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log(...args: string[]) {
    if (isDev) {
      console.log(...logPrefix, ...args);
    }
  },
  warn(...args: string[]) {
    if (isDev) {
      console.warn(...logPrefix, ...args);
    }
  },
  error(...args: string[]) {
    console.error(...logPrefix, ...args);
  },
};

export default logger;
